import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, useIntl } from 'react-intl';

import Heading from '@bibliocommons/heading';

import cardShape from 'app/shapes/cardShape';
import PromosInfoModal from 'app/components/bibs/shared/PromosInfoModal';
import ContentCard from 'app/components/cards/ContentCard';

import './EventCards.scss';

const EventCards = ({
  eventCards,
  trackEventCardImpression,
  trackEventCardLocationClick,
  trackEventCardTitleClick
}) => {
  const intl = useIntl();

  const infoScreenReaderLabel = intl.formatMessage({
    defaultMessage: 'About upcoming events',
    id: 'about_upcoming_events'
  });

  if (eventCards.size === 0) {
    return null;
  }

  return (
    <section className="cp-bib-event-cards">
      <div className="container">
        <div className="row">
          <div className="col-lg-3">
            <Heading className="heading" size="moderate" tagName="h2" variant>
              <FormattedMessage id="upcoming_events" />
              <PromosInfoModal className="info" infoScreenReaderLabel={infoScreenReaderLabel} />
            </Heading>
          </div>

          <div className="col-lg-8">
            <div className={cn('cards', { 'cards--multi': eventCards.size > 1 })}>
              {eventCards.map((card, index) => {
                const position = index + 1;

                return (
                  <ContentCard
                    className="event-card"
                    card={card}
                    dateStampSize="default"
                    handleContentImpression={() => trackEventCardImpression({ card, position })}
                    handleTitleClick={() => trackEventCardTitleClick({ card, position })}
                    hasBackground={false}
                    hasBorder={false}
                    hasDescription={false}
                    hasType={false}
                    key={`event-card_${card.get('id')}`}
                    trackEventLocationClick={({ linkText }) =>
                      trackEventCardLocationClick({ card, linkText, position })}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

EventCards.propTypes = {
  eventCards: ImmutablePropTypes.listOf(cardShape).isRequired,
  trackEventCardImpression: PropTypes.func.isRequired,
  trackEventCardLocationClick: PropTypes.func.isRequired,
  trackEventCardTitleClick: PropTypes.func.isRequired
};

export default EventCards;
